"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgRocket = function SvgRocket(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M8.54 11.158A1 1 0 019 12v1.131l1-.666V10c0-.256.098-.512.293-.707 1.596-1.595 2.75-3.932 3.442-7.027-3.092.696-5.43 1.85-7.03 3.442a.997.997 0 01-.71.292h-2.46L2.87 7h1.129a1 1 0 01.71.296l.911.919a1.01 1.01 0 01.171.172l2.75 2.77zM7 12.446l-2.008-2.024-2.285 2.285a1 1 0 11-1.414-1.414l2.29-2.29L3.581 9H1a1 1 0 01-.832-1.555l2-3A1 1 0 013 4h2.598C7.752 2.008 10.837.687 14.834.014a1 1 0 011.152 1.15c-.669 4.003-1.99 7.09-3.986 9.24V13a1 1 0 01-.445.832l-3 2A1 1 0 017 15v-2.554zm-2.707-.153a1 1 0 111.414 1.414l-2 2a1 1 0 11-1.414-1.414l2-2zM10 7a1 1 0 110-2 1 1 0 010 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

SvgRocket.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgRocket;
exports.default = _default;